import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {List} from 'antd-mobile';
import benefit_1 from "../../resources/images/icons/car-insurance.svg"
import benefit_2 from "../../resources/images/icons/fender-bender.svg"
import benefit_3 from "../../resources/images/icons/artificial-intelligence.svg"
import benefit_4 from "../../resources/images/icons/insurance.svg"
import {Link} from "react-router-dom";

const Item = List.Item;

class Dashboard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            isLoading: true,
            height: document.documentElement.clientHeight - 114,
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <div style={{backgroundColor: '#FFFFFF', height: '100%'}}>
                <List renderHeader={() => 'Mua Bảo Hiểm ô tô trực tuyến'} className="introList">
                    <Item thumb={benefit_1} multipleLine wrap>
                        Bảo vệ chiếc xe yêu quý của bạn ngay bây giờ, đặt mua 5', thẩm định 30'
                    </Item>
                    <Item thumb={benefit_2} multipleLine wrap>
                        Yêu cầu bồi thường nhanh chóng trong 30'
                    </Item>
                    <Item thumb={benefit_3} multipleLine wrap>
                        Thẩm định tự động với trí tuệ nhân tạo
                    </Item>
                    <Item thumb={benefit_4} multipleLine wrap>
                        Quản lý hợp đồng trực tuyến, gia hạn dễ dàng
                    </Item>
                    <Item>
                        <div className='boxBuyNow'>
                            <Link to='/chon-xe-mua-bao-hiem' className="ant-btn btn-next-action">Mua ngay</Link>
                        </div>
                    </Item>
                </List>
            </div>
        )
    }
}

export default (withTranslation())(Dashboard);